__turbopack_context__.v({
  "contact": "uykD2a_contact",
  "contactEmail": "uykD2a_contactEmail",
  "content": "uykD2a_content",
  "customerSupport": "uykD2a_customerSupport",
  "form": "uykD2a_form",
  "headline": "uykD2a_headline",
  "image": "uykD2a_image",
});
